import { Tab } from '@headlessui/react'
import clsx from 'clsx'
import { FC } from 'react'

import { cn } from '@/app/utils'

import { TabItem } from './Tabs.types'

type Props = {
  selectedIndex?: number
  onChange?: (index: number) => void
  options: TabItem[]
  className?: string
  tabClassName?: string
  selectedTabClassName?: string
  listClassName?: string
  noPanels?: boolean
  counter?: { key: string; count: number }
  dataTestId?: string
}

const TabsRounded: FC<Props> = ({
  selectedIndex,
  onChange,
  options,
  className,
  noPanels,
  tabClassName,
  selectedTabClassName,
  listClassName,
  counter,
  dataTestId
}) => {
  return (
    <div className={clsx(className)}>
      <Tab.Group selectedIndex={selectedIndex} onChange={onChange}>
        <Tab.List
          className={cn(
            'grid auto-cols-fr grid-flow-col gap-12 rounded-12 border border-grey-40',
            listClassName
          )}
          data-testid={dataTestId}
        >
          {options.map(item => (
            <Tab
              key={item.key}
              className={({ selected }) =>
                cn(
                  '',
                  '-m-1 flex flex-col items-center justify-center rounded-12 px-22 py-14 transition-all text-18 md:py-10 md:text-16',
                  selected
                    ? ['bg-grey-70 text-white/90', selectedTabClassName]
                    : ['text-grey-70 hover:text-grey-100', tabClassName],
                  item.title && item.description ? 'pt-6' : ''
                )
              }
            >
              {item.title && (
                <p className="relative font-bold text-18 xxs:text-16">
                  {item.title}
                  {counter &&
                    item.key === counter?.key &&
                    counter.count > 0 && (
                      <span className="absolute -top-1 pl-4 font-bold text-bronze-20 text-16 sm:text-12">
                        {counter?.count}
                      </span>
                    )}
                </p>
              )}
              {item.description && (
                <span className="font-pro text-12">{item.description}</span>
              )}
            </Tab>
          ))}
        </Tab.List>

        {!noPanels && (
          <Tab.Panels className="mt-56 md:mt-30">
            {options.map(item => (
              <Tab.Panel key={item.key}>{item.panelRender}</Tab.Panel>
            ))}
          </Tab.Panels>
        )}
      </Tab.Group>
    </div>
  )
}

export default TabsRounded
